import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileEventBus {

    public readonly updated = new Subject<void>();

    constructor() { }

}